import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService} from '../../../../services/commande-client/data.service';
import {HeaderService} from '../../../../services/header/header.service';
import {ExportService} from '../../shared/export.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-bon-sortie',
  templateUrl: './bon-sortie.component.html',
  styleUrls: ['./bon-sortie.component.scss']
})
export class BonSortieComponent implements OnInit {

    currentStatus: string = 'tous';
    statuses: string[] = ['tous', 'brouillon', 'cree', 'annule', 'ferme'];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService,
        private headerService: HeaderService,
        private exportService: ExportService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        console.log('BonSortieComponent initialized');
        this.headerService.setConfig({
            title: 'Bon de Sortie',
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: [
                        {
                            label: 'PDF',
                            action: () => this.exportService.triggerPDF(),
                            icon: '../../../assets/images/logo/pdf_logo.png'
                        },
                        {
                            label: 'CSV',
                            action: () => this.exportToCSV(),
                            icon: '../../../assets/images/logo/csv_logo.png'
                        }
                    ]
                }
            ]
        });
        // Mettre à jour currentStatus à partir de l'URL
        this.route.firstChild?.url.subscribe(segments => {
            const path = segments.length > 0 ? segments[0].path : 'tous';
            this.currentStatus = path.toLowerCase();
            console.log('Current status set to:', this.currentStatus); // Debug
        });
    }

    filterByStatus(status: string) {
        this.currentStatus = status.toLowerCase();
        console.log('Navigating to:', `/vente/bon-sortie/${status}`); // Debug
        this.router.navigate([`/vente/bon-sortie/${status}`]).then(success => {
            if (!success) {
                console.error('Navigation failed for status:', status);
                this.toastr.error('Erreur de navigation');
            }
        });
    }

    getStatusCount(status: string): number {
        return this.dataService.getBonSortieStatusCount(status);
    }

    private exportToCSV(): void {
        const data = this.dataService.getBonLivraisonTableData();
        const headers = ['Référence', 'Client', 'Date', 'Revenu', 'Matricule', 'Statut'];
        const rows = data.map(item => [
            `"${(item.reference || '').replace(/"/g, '""')}"`,
            `"${(item.clientName || '').replace(/"/g, '""')}"`,
            `"${(item.date || '').replace(/"/g, '""')}"`,
            `"${(item.revenue || '').replace(/"/g, '""')}"`,
            `"${(item.matricule || '').replace(/"/g, '""')}"`,
            `"${(item.status || '').replace(/"/g, '""')}"`
        ]);
        const csvContent = headers.join(',') + '\n' + rows.map(row => row.join(',')).join('\n');
        this.exportService.downloadCSV(csvContent, 'bon-sortie.csv');
    }

}
